import React from "react";
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";

const DialogClicks = ({ open, onClose, clicks, loading }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{ sx: { borderRadius: 3 } }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography
          variant="h6"
          sx={{ fontFamily: "Rubik", fontWeight: "bold", color: "#0b3d87" }}
        >
          Dettaglio ultimi 20 click
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        {loading ? (
          <Typography
            sx={{
              fontFamily: "Rubik",
              color: "#808080",
              textAlign: "center",
              py: 3,
            }}
          >
            Caricamento...
          </Typography>
        ) : !clicks || clicks.length === 0 ? (
          <Typography
            sx={{
              fontFamily: "Rubik",
              color: "#808080",
              textAlign: "center",
              py: 3,
            }}
          >
            Nessun click disponibile.
          </Typography>
        ) : (
          <Box>
            <Table sx={{ tableLayout: "fixed", width: "100%" }}>
              <TableHead sx={{ backgroundColor: "#003366" }}>
                <TableRow>
                  <TableCell
                    sx={{
                      fontFamily: "Rubik",
                      color: "white",
                      fontWeight: "bold",
                      width: "25%",
                    }}
                  >
                    Data/Ora click
                  </TableCell>
                  <TableCell
                    sx={{
                      fontFamily: "Rubik",
                      color: "white",
                      fontWeight: "bold",
                      width: "45%",
                    }}
                  >
                    Browser / IP
                  </TableCell>
                  <TableCell
                    sx={{
                      fontFamily: "Rubik",
                      color: "white",
                      fontWeight: "bold",
                      width: "30%",
                    }}
                  >
                    Catalogo ID
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {clicks.map((row, index) => (
                  <TableRow
                    key={index}
                    sx={{
                      backgroundColor: index % 2 === 0 ? "#f0f5ff" : "white",
                    }}
                  >
                    <TableCell
                      sx={{
                        fontFamily: "Rubik",
                        fontWeight: "bold",
                      }}
                    >
                      {row.dateLabel}
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily: "Rubik",
                      }}
                    >
                      {row.browser} · {row.ip}
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily: "Rubik",
                      }}
                    >
                      {row.catalogId}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          sx={{
            fontFamily: "Rubik",
            textTransform: "none",
            fontWeight: "bold",
            color: "#0b3d87",
          }}
        >
          Chiudi
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogClicks;

